
    import {Component, FormComponentBase, Prop, Watch} from '@/lib';
    import TreeModal from './components/tree-modal.vue';
    @Component({name:"hi-tag-tree-input", components:{TreeModal}})
    export default class HiTagTreeInput extends FormComponentBase {
        @Prop({ type: Array, default: () => { return [] }, required: true }) value: any[];
        @Prop({type: Boolean, default: false}) isViewOnly; //是否预览
        @Prop({type: Boolean, default: true}) multiple: boolean; //是否多选 默认是
        @Prop({type: String}) queryAction: string; //数据源dispatch type
        @Prop({ type: Array }) storeState:Array<any>;
        // @Prop( {type:Array, required:true}) cols: Array<any>;
        @Prop({ type: String, default:"Action.Choose"} ) modalTitleL: string; //Modal Title

        tagList = [];
        chooseModalShow: boolean = false;
        currentValue = [];

        @Watch("value", {immediate: true, deep:true})
        watchValue(value) {
            if (value) {
                if (!!value && value.length != 0 && value != this.currentValue) {
                    this.tagList = [...value];
                    this.tagList = this.tagList.filter(item => {return item != undefined});
                    this.currentValue = this.tagList.map(item => {
                        return item.key
                    });
                }
            } else {
                //清除选择控件缓存
                this.tagList = [];
                this.currentValue = [];
            }
        }

        handleAdd() {
            this.chooseModalShow = true;
        }

        cancelCallBack() {
            this.chooseModalShow = false;
        }

        confirmCallBack(data) {
            this.chooseModalShow = false;
            this.$nextTick(() => {
                this.tagList = [...data];
                this.currentValue = this.tagList.map(item => {
                    return item.key
                });
                this.$emit("input", this.tagList);
            })

        }

        handleClose(event, name) {
            this.tagList.splice(name, 1);
            if (this.tagList.length == 0) {
                this.chooseModalShow = false;
                this.currentValue = [];
            } else {
                this.currentValue = this.tagList.map(item => {
                    return item.key
                });
            }
            this.$emit("input", this.tagList);
        }

        get requiredRule() {
            return {
                required: true,
                type: "array",
                min: 1,
                message: this.L("Validate.PleaseSelect", this.L(this.labelKey)),
                trigger: "change"
            }
        }
    }
